<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row">
          <div class="col-lg-4 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded h-100">
              <div class="card-header dag-box">
              </div>
              <div class="card-body p-t-20 p-b-30">
                <div class="d-flex align-items-center">
                  <div class="card-icon"
                       v-if="getFAQ[objIndex].Image">
                    <img :src="require(`@/assets/img/Food icons/${getFAQ[objIndex].Image}`)" width="100">
                  </div>
                  <div class="card-link">
                    <a class="card-link-24 text-dag" href="#">
                      {{ getFAQ[objIndex].Title }}
                    </a>
                  </div>
                </div>
                <div class="p-t-15">
                  <span v-html="getFAQ[objIndex].Text"></span>
                  <div class="p-t-25 d-block">
                    <router-link class="nextbutton bg-24 text-white d-block"
                                 :to="{ name: 'FAQ'}">
                      {{ $t('survey_back') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['faq_id'],
    computed: {
      ...mapGetters([
        'getShiftClass',
        'getFAQ',
      ]),
      objIndex() {
        return this.getFAQ.findIndex((obj => obj.Id === this.faq_id))
      },
    },
    data() {
      return {
      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/info/FAQPage.vue